import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { useAnalytics } from "../../firebase/hooks/useAnalytics";
import rightSide from "../../assets/newHome.jpg";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const { trackPageView } = useAnalytics();

    // Helper to get language from URL
    const getLangFromUrl = () => {
        const params = new URLSearchParams(location.search);
        return params.get("lang") === "zh" ? "zh" : "en";
    };

    const language = getLangFromUrl();
    const isEN = language === "en";

    // Track page view when component mounts
    useEffect(() => {
        trackPageView("Forgot Password");
    }, [trackPageView]);

    // Update URL when language changes
    const setLanguageInUrl = (lang) => {
        const params = new URLSearchParams(location.search);
        params.set("lang", lang);
        navigate({ search: params.toString() }, { replace: true });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const auth = getAuth();
        try {
            // console.log("Password reset link sent to:", email);
            await sendPasswordResetEmail(auth, email);
            alert(isEN ? "Password reset link sent!" : "密碼重置連結已發送！");
            navigate({ pathname: "/login", search: `?lang=${language}` });
        } catch (error) {
            if (error.code === "auth/user-not-found") {
                alert(
                    isEN
                        ? "This email is not registered."
                        : "此電子郵件未註冊。"
                );
            } else {
                alert(
                    (isEN
                        ? "Failed to send reset link: "
                        : "重置連結發送失敗：") + error.message
                );
            }
        }
    };

    return (
        <div className="lg:flex h-screen font-sans relative">
            {/* Left Panel */}
            <div className="flex justify-center items-center lg:bg-slate-100 lg:w-1/2 relative z-10 min-h-screen lg:min-h-0">
                <div className="w-11/12 sm:w-3/4 lg:w-3/4 p-6 sm:p-8 bg-white/95 lg:bg-slate-100 backdrop-blur-sm lg:backdrop-blur-none rounded-xl lg:rounded-lg shadow-xl lg:shadow-none">
                    {/* Language Switcher */}
                    <div className="flex justify-end mb-4">
                        <button
                            onClick={() => setLanguageInUrl("en")}
                            className={`text-sm ml-2 px-2 py-1 rounded transition-all duration-200 ${
                                language === "en"
                                    ? "bg-orange-600 text-white"
                                    : "text-gray-600 hover:bg-gray-200"
                            }`}
                        >
                            English
                        </button>
                        <button
                            onClick={() => setLanguageInUrl("zh")}
                            className={`text-sm ml-2 px-2 py-1 rounded transition-all duration-200 ${
                                language === "zh"
                                    ? "bg-orange-600 text-white"
                                    : "text-gray-600 hover:bg-gray-200"
                            }`}
                        >
                            繁體中文
                        </button>
                    </div>

                    {/* Logo */}
                    <div
                        onClick={() =>
                            navigate({
                                pathname: "/",
                                search: `?lang=${language}`,
                            })
                        }
                        className="flex items-center gap-6 mb-8"
                    >
                        <img
                            src="logo_tglobal.png"
                            alt="T-Global"
                            className="w-48 h-auto"
                        />
                    </div>

                    {/* Header */}
                    <div className="text-center mb-6">
                        <div className="text-lg font-medium text-gray-800">
                            {isEN ? "Enter Your Account Email" : "忘記密碼"}
                        </div>
                    </div>

                    {/* Reset Password Form */}
                    <form
                        onSubmit={handleSubmit}
                        className="flex flex-col space-y-4"
                    >
                        <label className="text-gray-700 font-medium">
                            {isEN ? "Email" : "電子郵件"}
                        </label>
                        <input
                            type="email"
                            placeholder={
                                isEN
                                    ? "Enter your business email"
                                    : "請輸入商業電子郵件"
                            }
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                        />

                        <button
                            type="submit"
                            className="w-full p-3 bg-orange-600 hover:bg-orange-700 text-white font-bold rounded-md mt-5 transition-colors duration-200"
                        >
                            {isEN ? "Reset Password" : "重置密碼"}
                        </button>
                    </form>
                </div>
            </div>

            {/* Right Panel */}
            <div className="lg:hidden absolute inset-0 z-0">
                <img
                    src={rightSide}
                    alt=""
                    className="w-full h-full object-cover"
                />
                {/* Dark overlay for better text readability */}
                <div className="absolute inset-0 bg-black/40"></div>
            </div>

            {/* Right Panel */}
            <div className="lg:w-1/2 hidden lg:block flex-1 bg-slate-100 overflow-hidden relative p-8">
                <img
                    src={rightSide}
                    alt=""
                    className="w-full h-full object-cover rounded-xl "
                />
            </div>
        </div>
    );
}
